import { cloneDeep } from "lodash";
import { AioReplacement } from "./interface";

/**
 * Append an incoming replacement to existing subLists.
 *
 * @param incoming - The incoming replacement to append
 * @param subLists - The existing sub lists to append to
 * @returns AioReplacement<T>[] | undefined
 */
export const appendReplacement = <T>(
  incoming: AioReplacement<T>,
  subLists?: AioReplacement<T>[],
): AioReplacement<T>[] | undefined => {
  let newSubLists: AioReplacement<T>[] = [];

  if (subLists === undefined || subLists.length === 0) {
    newSubLists.push(cloneDeep(incoming));
  } else {
    newSubLists = subLists.map((s) => {
      return {
        ...s,
        newTexts: s.newTexts.map((nt) => {
          return {
            ...nt,
            subLists: appendReplacement(incoming, nt.subLists),
          };
        }),
      };
    });
  }
  return newSubLists;
};
